import { render, staticRenderFns } from "./main-menu-grouping-mobile-dropdown.vue?vue&type=template&id=1167d77c&"
import script from "./main-menu-grouping-mobile-dropdown.vue?vue&type=script&lang=ts&"
export * from "./main-menu-grouping-mobile-dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./main-menu-grouping-mobile-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports